module.exports = __webpack_public_path__ + "images/icons_v2/filter-filled-ce2fdf92.svg";